import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { SubscriptionCategory } from '../../../../../../common/enums.js';
import { EoeSubscriptionDetailsVoice } from '../../../../../../components/EoeSubscriptionDetails/EoeSubscriptionDetailsVoice.js';
import {
  checkValidEmployeeSubscription,
  getEmployeeSubscriptions,
} from '../../../../../../selfservice/actions/index.js';
import type { SubscriptionId } from '../../../../../../common/constants/pathInterfaces.js';

export const EoeVoiceSubPath = () => {
  const { subscriptionId = '' } = useParams<SubscriptionId>();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getEmployeeSubscriptions(SubscriptionCategory.VOICE, subscriptionId));
    dispatch(checkValidEmployeeSubscription(SubscriptionCategory.VOICE, subscriptionId));
  }, [dispatch, subscriptionId]);

  return <EoeSubscriptionDetailsVoice subscriptionId={subscriptionId} />;
};
